var ChangePasswordModel = require('../models/modals/change-password-form');
var ClientModel = require('../../../models/client');
var ProfileInfoView = require('./components/profile-info.js');

var ProfileView = Backbone.Epoxy.View.extend({
  AUTO_CLOSE_TIMEOUT: 3000,

  /**
   * Name of the template file to use to render (search path is /assets/templates/app)
   * Directory separators are replaced with periods.
   */
  template: 'account.profile',

  /**
   * The `bindings` attribute should be set to `'data-bind'` if you will use data binding.
   *
   * This tells Epoxy to look for binding declarations in the data-bind attributes in the HTML markup.
   */
  bindings: 'data-bind',

  /**
   * Backbone events.  Hash of 'dom-event-name css-selector' : '{functionName}'
   */
  events: {
    'click .upcoming-appointments': 'onUpcomingAppointments',
    'keydown .upcoming-appointments': 'onUpcomingAppointments',
    'click .waiting-list': 'onWaitingList',
    'keydown .waiting-list': 'onWaitingList',
    'click .wait-board': 'onWaitBoard',
    'keydown .wait-board': 'onWaitBoard',
    'click .my-reviews': 'onMyReviews',
    'keydown .my-reviews': 'onMyReviews',
    'click .update-profile' : 'updateProfile',
    'click .service-history': 'onServiceHistory',
    'keydown .service-history': 'onServiceHistory',
    'click .change-password': 'changePassword',
    'keydown .change-password': 'changePassword',
    'click .logout-btn': 'onAccountLogout',
    'keydown .logout-btn': 'onAccountLogout',
    'click .sign-in-link': 'signInLink',
    'keydown .sign-in-link': 'signInLink',
    'click #profileChanged': 'resetMessage',
    'submit #profileForm': function() { return false; },
    'click #changePasswordButton': 'changePassword',
    'keydown #changePasswordButton': 'changePassword',
    'submit #passwordForm': function() { return false; },
    'focus .form-control': function(e) { this.$(e.target).select(); }

  },

  bindingSources: {
    pwd: function() {
      return new ChangePasswordModel();
    }
  },

  /**
   * Called when this object is instantiated.
   */
  initialize: function() {
    this.model = new ClientModel();

    if (bookedby.staticData.storeGroupSettings.reduceClientNeededInfo) {
      this.model.set('useFullName', true);
    }

    var self = this;
    $(window).resize(function() {
      self.fixContentHeight();
    })
  },

  fixContentHeight: function () {
    var topBarHeight = $('.top-bar').height();
    var height = $(window).height() - topBarHeight;

    $('#clientProfile').css('height', height);
  },

  signInLink: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          var self = this;
          bookedby.app.showLogin(function () {
              self.setData();
          });
      }
  },

  /**
   * Called before this view is displayed to the user.
   * Clean up defaults and reset page status, etc.
   * Returns a boolean to signify whether the rendering should continue.
   */
  beforeRender: function() {
    this.setView('.profile-info-area', new ProfileInfoView({
      model: this.model,
      showPasswordFields: false
    }));
    if (!bookedby.app.currentClient.get("loggedIn") ) {
      bookedby.app.navigateWithNoAuth('login', {}, 'profile', {});
      return false;
    } else {
      return true;
    }

  },

  /**
   * Called after this view is displayed.
   * Set focus, do after-render animations, etc.
   */
  afterRender: function() {
    //You must keep this line if you want to use data binding, otherwise remove it
    this.applyBindings();

    this.fixContentHeight();

    bookedby.app.finishLoading();
  },

  /**
   * Called before your view is removed from the DOM.
   *
   * If you attach custom events or initialize UI components in afterRender(), you should remove those events or destory those components here.
   */
  cleanup: function() {
    //You must keep this line if you want to use data binding, otherwise remove it
    this.removeBindings();
  },

  refresh: function() { // called from logout function when available
    if (!bookedby.app.currentClient.get("loggedIn") ) {
      bookedby.app.navigateWithNoAuth('login', {}, 'profile', {}, true);
      return;
    }

    this.setData();
  },


  /**
   * Called on navigation.
   *
   * * newData is an object parsed from the URL query parameters
   * * path is set to the name of the page/route
   */
  setData: function() {
    $.ajax({
      url: bookedby.routes.AUTHENTICATION.CHECK_LOGIN,
      contentType: 'application/json',
      method: 'POST',
      dataType: 'json',
      cache: false,
      success: _.bind(function(data) {
        if (data.isLogged) { // since the session might terminate in another tab we need to check before showing the data and force the login
          Backbone.Validation.unbind(this.model);
          if(bookedby.app.currentClient.get("loggedIn") && bookedby.app.currentClient.get("email") != null &&
            bookedby.app.currentClient.get("email").length > 1) {
            this.model.set("fullName", bookedby.app.currentClient.get("fullName"));
            this.model.set("firstName", bookedby.app.currentClient.get("firstName"));
            this.model.set("lastName", bookedby.app.currentClient.get("lastName"));
            this.model.set("phone", bookedby.app.currentClient.get("phone1"));
            this.model.set("email", bookedby.app.currentClient.get("email"));
            this.model.set("gender", bookedby.app.currentClient.get("gender"));
            this.model.set("birthday", bookedby.app.currentClient.get("birthday") ? moment(bookedby.app.currentClient.get("birthday"), 'YYYY-MM-DD').format('MM-DD-YYYY') : null);
            this.model.set("zipCode", bookedby.app.currentClient.get("zipCode"));
            this.model.set("confirmationType", bookedby.app.currentClient.get("confirmationType"));
            this.model.set("smsOptIn", bookedby.app.currentClient.get("smsOptIn"));
            this.model.set("smsMarketingOptIn", bookedby.app.currentClient.get("smsMarketingOptIn"));
            this.model.set("origSmsMarketingOptIn", bookedby.app.currentClient.get("origSmsMarketingOptIn"));
            //Logged in clients are over-13 by definition, as they must be in order to register
            this.model.set("over13backing", true);
            this.model.set("updatedSuccess", false);
          } else {
            this.model.set(this.model.defaults);
          }
          Backbone.Validation.bind(this.model, {liveValidation: true});
        } else {
          bookedby.app.navigateWithNoAuth('login', {}, 'profile', {});
        }
      }, this)
    });
  },

  /**
   * AJAX call to update the profile details, and load the new values into the global scope.
   */
  updateProfile: function() {
    this.model.validationSuspended = true;
    var reduceClientInfo = bookedby.staticData.storeGroupSettings.reduceClientNeededInfo;

    var isValid = this.model.isValid(true);

    if (reduceClientInfo) {
      isValid = this.model.isValid(['firstName', 'lastName', 'email', 'zipCode', 'phone', 'birthday', 'over13']);
    }

    if(isValid) {
      bookedby.app.updateCurrentClientProfile(this.model).then(function(updatedCurrentClient) {
          bookedby.app.confirmForm.show(_.noop, _.noop, {
            message: 'Your account details have been updated.',
            confirmLabel: 'OK',
            showCancelLabel: false
          });

      }, function(responseError) {
        if (responseError.userError) {
          bookedby.app.confirmForm.show(_.noop, _.noop, {
            message: responseError.error,
            title: 'Profile was not updated',
            confirmLabel: 'OK',
            showCancelLabel: false
          });
        }
        if (responseError.errorType == 'noAuthentication') {
          bookedby.app.navigateWithNoAuth('login', {}, 'profile', {});
        }
      });
    }
  },

  changePassword: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.bindingSources.pwd.set("validationSuspended", false);
          if (this.bindingSources.pwd.isValid(true)) {
              $.ajax({
                  url: bookedby.routes.AUTHENTICATION.CHANGE_PASSWORD,
                  method: "POST",
                  data: JSON.stringify(this.bindingSources.pwd.toJSON()),
                  contentType: "application/json",
                  cache: false,
                  success: function (data) {
                      var options = {
                          message: '',
                          cancelLabel: '',
                          confirmLabel: 'Ok',
                          showCancelLabel: false
                      };

                      if (!data.success) {
                          if (data.userError) {
                            options.message = data.error;
                            bookedby.app.confirmForm.show(function () {
                              }, function () {
                              }, options);
                          } else {
                              bookedby.app.logAPIError(data.error);

                              if (data.errorType == 'noAuthentication') {
                                  bookedby.app.navigateWithNoAuth('login', {}, 'profile', {});
                              }
                          }
                      } else {
                          bookedby.app.currentClient.logIn({client: data});
                          bookedby.app.onLoggedInChange();

                          this.bindingSources.pwd.set('validationSuspended', true);
                          this.bindingSources.pwd.set(this.bindingSources.pwd.defaults);

                          options.message = 'Your password has been updated.';
                          bookedby.app.confirmForm.show(function () {
                          }, function () {
                          }, options);
                      }
                  }.bind(this),
                  error: _.bind(function (jqXHR, textStatus, textError) {
                      bookedby.app.logAPIError(textError);
                  }, this)
              });
          }
      }
  },

  onUpcomingAppointments: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('upcoming-appointments');
      }
  },

  onWaitingList: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('waiting-list');
      }
  },

  onWaitBoard: function(e) {
    if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
        this.changeTab('wait-board');
    }
  },

  onMyReviews: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          bookedby.app.navigateTo('client-reviews');
      }
  },

  onServiceHistory: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('service-history');
      }
  },

  onAccountLogout: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.changeTab('logout');
      }
  },

  resetMessage: function(e) {
      if(e.type !== "keydown" || e.type === "keydown" && e.keyCode === 13) {
          this.model.set("updatedSuccess", false);
      }
  },

  hasChanges: function() {
    var reduceClientInfo = bookedby.staticData.storeGroupSettings.reduceClientNeededInfo;
    var currentClient = bookedby.app.getCurrentClient();

    return reduceClientInfo ? (
      currentClient.get("email") != this.model.get("email") ||
      currentClient.get('phone') != this.model.get('phone') ||
      currentClient.get('fullName') != this.model.get('fullName') ||
      currentClient.get("zipCode") != this.model.get("zipCode")
    ) : (
      currentClient.get("firstName") != this.model.get("firstName") ||
      currentClient.get("lastName") != this.model.get("lastName") ||
      currentClient.get("phone1") != this.model.get("phone") ||
      currentClient.get("email") != this.model.get("email") ||
      currentClient.get("gender") != this.model.get("gender") ||
      currentClient.get("zipCode") != this.model.get("zipCode") ||
      currentClient.get("smsOptIn") != this.model.get("smsOptIn") ||
      currentClient.get("smsMarketingOptIn") != this.model.get("smsMarketingOptIn") ||
      currentClient.get("confirmationType") != this.model.get("confirmationType")) ||
      (!currentClient.get("birthday") ? null : moment(currentClient.get("birthday"), 'YYYY-MM-DD').format('MM-DD-YYYY')) != this.model.get("birthday");
  },

  changeTab: function(route) {
    var options = {
      message: 'You have unsaved changes. Do you want to discard them?',
      cancelLabel: 'Cancel',
      confirmLabel: 'Ok',
      showCancelLabel: true
    };

    if(this.hasChanges()) {
      bookedby.app.confirmForm.show(_.bind(function() {
        this.navigate(route);
      }, this), function() {}, options);
    } else {
      this.navigate(route);
    }
  },

  navigate: function(route) {
    if(route == 'logout') {
      var options = {
        message: 'Are you sure you want to logout?',
        cancelLabel: 'Go Back',
        confirmLabel: 'Logout',
        showCancelLabel: true
      };

      bookedby.app.confirmForm.show(_.bind(function(){
        bookedby.app.logOut();
      }, this), function() {}, options);
    } else {
      bookedby.app.navigateTo(route);
    }
  }

});

/**
 * Export this view as a class.
 */
module.exports = ProfileView;
